import { useQuery } from "@tanstack/react-query";
import { quoteService } from "@/services/quoteService";

export function useQuote(instrumentToken: string | null) {
  return useQuery({
    queryKey: ["market-data", "quote", instrumentToken],
    queryFn: () => quoteService.getQuote(instrumentToken as string),
    enabled: Boolean(instrumentToken),
  });
}

export function useHistoricalCandles(instrumentToken: string | null, timeframe: string) {
  return useQuery({
    queryKey: ["market-data", "history", instrumentToken, timeframe],
    queryFn: () => quoteService.getHistory(instrumentToken as string, timeframe),
    enabled: Boolean(instrumentToken),
  });
}
